import { render, staticRenderFns } from "./platformByProjectOrder.vue?vue&type=template&id=5b8881fb&scoped=true"
import script from "./platformByProjectOrder.vue?vue&type=script&lang=js"
export * from "./platformByProjectOrder.vue?vue&type=script&lang=js"
import style0 from "./platformByProjectOrder.vue?vue&type=style&index=0&id=5b8881fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8881fb",
  null
  
)

export default component.exports